import React from 'react';
import { Player } from '../../../domain/entities';
import './HiddenStatsPanel.css';

interface HiddenStatsPanelProps {
    player: Player;
}

export const HiddenStatsPanel: React.FC<HiddenStatsPanelProps> = ({ player }) => {
    return (
        <div className="panel hidden-stats-panel">
            <div className="panel-header">Hidden Stats 🤫</div>
            <div className="panel-content">
            <div className="hidden-stats-grid">
                {/* Core Stats */}
                <div className="hidden-stats-section">
                    <div className="hidden-stats-section-title">Core Stats</div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">ID</span>
                        <span className="hidden-stats-value">{player.id}</span>
                    </div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Potential</span>
                        <span className="hidden-stats-value">{player.potential}</span>
                    </div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Expected Wage</span>
                        <span className="hidden-stats-value">£{Math.round(player.expectedWage || 0).toLocaleString()}</span>
                    </div>
                </div>

                {/* Fitness Stats */}
                <div className="hidden-stats-section">
                    <div className="hidden-stats-section-title">Fitness Stats</div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Fitness</span>
                        <span className="hidden-stats-value">{Math.round(player.fitness)}</span>
                    </div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Fitness Max</span>
                        <span className="hidden-stats-value">{player.fitnessMax}</span>
                    </div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Recovery Rate</span>
                        <span className="hidden-stats-value">{Math.round(player.fitnessRecovery)}/week</span>
                    </div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Fitness Loss</span>
                        <span className="hidden-stats-value">{Math.round((15 - (player.fitnessMax - 85) / 2) * 10) / 10}/game</span>
                    </div>
                </div>

                {/* Flexibility Stats */}
                <div className="hidden-stats-section">
                    <div className="hidden-stats-section-title">Flexibility Stats</div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Category</span>
                        <span className="hidden-stats-value">{player.flexibility ? Math.round(player.flexibility.categoryFlexibility) : '—'}</span>
                    </div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Foot</span>
                        <span className="hidden-stats-value">{player.flexibility ? Math.round(player.flexibility.footFlexibility) : '—'}</span>
                    </div>
                </div>

                {/* Contract & Status */}
                <div className="hidden-stats-section">
                    <div className="hidden-stats-section-title">Contract & Status</div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Contract Exp</span>
                        <span className="hidden-stats-value">S{player.contract.expirySeason}</span>
                    </div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Injury</span>
                        <span className="hidden-stats-value">{player.injury ? `${player.injury.type} (${player.injury.duration}w)` : 'None'}</span>
                    </div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Last Season Δ</span>
                        <span className="hidden-stats-value">{player.lastSeasonChange}</span>
                    </div>
                </div>

                {/* Personality */}
                <div className="hidden-stats-section">
                    <div className="hidden-stats-section-title">Personality</div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Personality</span>
                        <span className="hidden-stats-value">{player.personality}</span>
                    </div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Morale Reason</span>
                        <span className="hidden-stats-value">{player.moraleReason}</span>
                    </div>
                </div>

                {/* Other */}
                <div className="hidden-stats-section">
                    <div className="hidden-stats-section-title">Other</div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Promoted?</span>
                        <span className="hidden-stats-value">{player.isPromotedYouth ? 'Yes' : 'No'}</span>
                    </div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Legend?</span>
                        <span className="hidden-stats-value">{player.isLegend ? 'Yes' : 'No'}</span>
                    </div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Training Focus</span>
                        <span className="hidden-stats-value">{player.trainingFocus || 'Default'}</span>
                    </div>
                    <div className="hidden-stats-row">
                        <span className="hidden-stats-label">Wants Talk?</span>
                        <span className="hidden-stats-value">{player.wantsToTalk ? 'Yes' : 'No'}</span>
                    </div>
                    {player.lastManagerTalk && (
                        <div className="hidden-stats-row">
                            <span className="hidden-stats-label">Last Talk</span>
                            <span className="hidden-stats-value">S{player.lastManagerTalk.season} W{player.lastManagerTalk.week}</span>
                        </div>
                    )}
                </div>
            </div>
            </div>
        </div>
    );
};
